import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesRecursoRecebidoInicio: [],
    buscaDetalhesRecursoRecebidoSucesso: ['detalhesRecursoRecebido'],
    buscaDetalhesRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
}

// Ação para busca completa
Creators.buscaDetalhesRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaDetalhesRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesRecursoRecebidoErro(error)))
    }
}

const buscaDetalhesRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_RECURSO_RECEBIDO_INICIO]: buscaDetalhesRecursoRecebidoInicio,
    [Types.BUSCA_DETALHES_RECURSO_RECEBIDO_ERRO]: buscaDetalhesRecursoRecebidoErro,
    [Types.BUSCA_DETALHES_RECURSO_RECEBIDO_SUCESSO]: buscaDetalhesRecursoRecebidoSucesso,
})
